import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useBooking } from '../../hooks/useBooking';
import { primaryButtonStyle, useSiteColors } from '../../hooks/useSiteColors';

export function StickyBookButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const { businessListing } = useBooking();
  const c = useSiteColors();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Only show on the home page
  if (location.pathname !== '/') return null;
  if (!businessListing) return null;

  const ctaLabel = businessListing.cta_label ?? 'Book Now';

  return (
    <div
      className="fixed bottom-6 left-1/2 z-50 transition-all duration-300 md:hidden"
      style={{
        opacity: visible ? 1 : 0,
        transform: `translateX(-50%) translateY(${visible ? 0 : 16}px)`,
        pointerEvents: visible ? 'auto' : 'none',
      }}
    >
      <button
        onClick={() => navigate('/book')}
        className="px-8 py-3.5 rounded-full text-[15px] font-semibold"
        style={primaryButtonStyle(c, 0.4)}
      >
        {ctaLabel}
      </button>
    </div>
  );
}
